import * as React from "react"
import { cva } from "class-variance-authority"

import { cn } from "@/lib/utils"
import { Card } from "@/components/ui/card"

// Wave 3 — EmptyState
// Shown when a list/section has no data yet. Consolidates the 7 ad-hoc
// variations currently in sections/ (TasksSection:345, RemindersSection:300,
// HabitsSection:341, ProjectsSection:405, FinanceSection:571, NotesSection:207,
// AutomationsSection:361).
//
// Props:
//   icon        — lucide icon component (required)
//   title       — headline string (required)
//   description — supporting text (optional)
//   action      — ReactNode slot for a CTA <Button> (optional)
//   tone        — domain color for the icon circle (default "neutral")

const toneStyles = cva("", {
  variants: {
    tone: {
      neutral:  "bg-surface-card-hover text-foreground-muted",
      task:     "bg-domain-task/10    text-domain-task",
      reminder: "bg-domain-reminder/10 text-domain-reminder",
      habit:    "bg-domain-habit/10   text-domain-habit",
      project:  "bg-domain-project/10 text-domain-project",
      finance:  "bg-domain-finance/10 text-domain-finance",
      note:     "bg-domain-note/10    text-domain-note",
      automation: "bg-domain-automation/10 text-domain-automation",
    },
  },
  defaultVariants: { tone: "neutral" },
})

export function EmptyState({ icon: Icon, title, description, action, tone, className }) {
  return (
    <Card variant="elevated" className={cn("flex flex-col items-center justify-center text-center py-12 px-8", className)}>
      {Icon && (
        <div className={cn("w-16 h-16 rounded-full flex items-center justify-center mb-5", toneStyles({ tone }))}>
          <Icon className="w-7 h-7" strokeWidth={1.75} />
        </div>
      )}
      <h3 className="text-h2 text-foreground mb-2">{title}</h3>
      {description && (
        <p className="text-body text-foreground-muted max-w-sm mb-6">{description}</p>
      )}
      {action && <div className="flex gap-3 justify-center">{action}</div>}
    </Card>
  )
}
